import React from 'react';
import { injectIntl, WrappedComponentProps } from 'react-intl';

const MS_IN_DAY = 1000 * 60 * 60 * 24;

function toYMD(date: Date) {
    return new Date(date.getFullYear(), date.getMonth(), date.getDate());
}

function getDeltaDays(date: Date) {
    return Math.floor((+toYMD(new Date()) - +toYMD(new Date(date))) / MS_IN_DAY);
}

function nearDay(date: Date) {
    const deltaDays = getDeltaDays(date);

    if (deltaDays === 1) {
        return 'yesterday';
    }

    if (deltaDays === 0) {
        return 'today';
    }

    if (deltaDays === -1) {
        return 'tomorrow';
    }

    return null;
}

interface Props extends WrappedComponentProps {
    date: Date;
    day?: Intl.DateTimeFormatOptions['day'];
    month?: Intl.DateTimeFormatOptions['month'];
    year?: Intl.DateTimeFormatOptions['year'];
}

/**
 * Возвращает дату в формате: вчера/сегодня/завтра/24 мая/24 мая 2014 г.
 **/
const HumanDate = ({ date, day = 'numeric', intl, month = 'long', year = 'numeric' }: Props) => {
    const nowDate = new Date();
    const eventDate = new Date(date);
    const nearDayName = nearDay(date);

    if (nearDayName) {
        return <>{intl.formatMessage({ id: `humanDate.nearDays.${nearDayName}` })}</>;
    }

    // текущий год без указания года
    if (nowDate.getFullYear() === eventDate.getFullYear()) {
        return <>{intl.formatDate(eventDate, { day, month })}</>;
    }

    return <>{intl.formatDate(eventDate, { day, month, year })}</>;
};

export default injectIntl(HumanDate);

export { nearDay };
